<template>
    <div>
        <div class="card">
            <div class="card__title">
                <span>Comprobantes coincidentes</span>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Número de comprobante</th>
                                        <th>Fecha de emisión</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(comprobante, index) in comprobantes" :key="index">
                                        <td>{{ comprobante.numero }}</td>
                                        <td>{{ moment(comprobante.fecha_emision).format('DD/MM/YYYY') }}</td>
                                        <td>
                                            <button @click="$emit('seleccionar', comprobante)" class="btn-info" type="button">
                                                <i class="fa fa-check"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row end-xs">
                    <button @click="$emit('cerrar')" class="btn-danger btn--text" type="button"><i class="fa fa-ban"></i> <span>Cerrar</span></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        comprobantes : {
            type : Array,
            required : true
        }
    },
    data : function () {
        return {
            moment : moment
        };
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/CoincidenciaComprobantes.vue